export enum SocketSelectionTypes {
    Input,
    Output,
}
